(function() {
    angular
        .module("app")
        .controller("MessageCreateV2Controller", MessageCreateV2Controller)

        MessageCreateV2Controller.$inject = [
        "$rootScope",
        "$sce",
        "$scope",
        "$timeout",
        "$uibModalInstance",
        "userMessagingService",
        "messageBoardsService",
        "messagesService",
        "messageBoard"
    ]

    function MessageCreateV2Controller(
        $rootScope,
        $sce,
        $scope,
        $timeout,
        $uibModalInstance,
        userMessagingService,
        messageBoardsService,
        messagesService,
        messageBoard
    ){

        const isMobile = window.innerWidth < 950

        $scope.loadingModal = true
        $scope.loadedModal  = { visibility: "hidden" }

        $scope.messageBoard = messageBoard

        $scope.messageNumber  = 1
        $scope.messageName    = "C001"
        $scope.messageNumbers = []
        $scope.isOverwrite    = false
        $scope.activate       = false

        $scope.showConfirmOverwrite     = false
        $scope.showConfirmCancelMessage = false
        $scope.showFont                 = false
        $scope.showStyle                = true

        $scope.Color         = FMMessage.Color
        $scope.Justification = FMMessage.Justification

        $scope.pages               = []
        $scope.currentPageNumber   = 1
        $scope.canAddPage          = false
        $scope.fonts               = []
        $scope.activeJustification = {}
        $scope.activeColor         = {}
        $scope.currentLineSpacing  = 1

        const isReady = [false, false]

        const onReady = () => {

            if (isReady.indexOf(false) >= 0) {
                isReady[isReady.indexOf(false)] = true
            }

            if (isReady.indexOf(false) < 0) {
                gtag("event", "create_message", { action: "begin", device_id: $scope.messageBoard.device.id, type: "TEXT" })

                $scope.loadingModal = false
                $scope.loadedModal  = { visibility: "visible" }
            }
        }

        messageBoardsService.getMessageNumbers($scope.messageBoard.id, (data) => {

            $scope.messageNumbers = []

            for (const n of data.existing) {
                $scope.messageNumbers.push({
                    number: n,
                    name:   $rootScope.generateMessageID("C", n),
                    exists: true
                })
            }

            for (const n of data.available) {
                $scope.messageNumbers.push({
                    number: n,
                    name:   $rootScope.generateMessageID("C", n),
                    exists: false
                })
            }

            if(data.available.length > 0) {
                $scope.messageNumber = data.available[0]
                $scope.isOverwrite = false
            } else {
                $scope.messageNumber = data.existing[0]
                $scope.isOverwrite = true
            }

            $scope.messageName = $rootScope.generateMessageID("C", $scope.messageNumber)

            onReady()

        })

        $scope.setMessageNumber = (messageSlot) => {

            if (messageSlot.exists) {
                $scope.isOverwrite = true
            } else {
                $scope.isOverwrite = false
            }

            $scope.messageNumber = messageSlot.number
            $scope.messageName   = $rootScope.generateMessageID("C", $scope.messageNumber)

        }

        $scope.deletePage = (page, force) => {

            if (isMobile && ($scope.showFont || $scope.showStyle)) {
                $scope.closeAllPanels()
                return
            }

            if (force || (page.number !== 1 && $scope.editController.interaction.isPageBlank(page.number))) {
                $scope.editController.interaction.deletePage(page.number)
                page.confirmDelete = false
            }

            page.confirmDelete = true

        }

        $scope.openPageTiming = (page) => {

            if (isMobile && ($scope.showFont || $scope.showStyle)) {
                $scope.closeAllPanels()
                return
            }

            page.openPageTiming = true

        }

        $scope.setLineSpacing = (up) => {

            let adjustment = 1

            if (!up) {
                adjustment = -1
            }

            $scope.editController.interaction.setLineSpacing($scope.currentLineSpacing + adjustment)

        }

        $scope.toggleFontPanel = () => {

            $scope.showFont = !$scope.showFont

            if (isMobile) {
                $scope.showStyle = false
            }
        }

        $scope.toggleStylePanel = () => {

            $scope.showStyle = !$scope.showStyle

            if (isMobile) {
                $scope.showFont = false
            }
        }

        $scope.closePopups = () => {
            for (const page of $scope.pages) {
                page.openPageTiming = false
                page.confirmDelete  = false
            }

            if (isMobile) {
                $scope.closeAllPanels()
            }
        }

        $scope.cancel = (force) => {

            if (isMobile && ($scope.showFont || $scope.showStyle)) {
                $scope.closeAllPanels()
                return
            }

            if (!force && $scope.showConfirmCancelMessage) {
                return
            }

            if (force || $scope.editController.interaction.isMessageBlank()) {
                gtag("event", "create_message", { action: "cancel", device_id: $scope.messageBoard.device.id, type: "TEXT" })
                $uibModalInstance.dismiss("cancel")
            } else {
                $scope.showConfirmCancelMessage = true
            }
        }

        $scope.resume = () => {

            if (isMobile && ($scope.showFont || $scope.showStyle)) {
                $scope.closeAllPanels()
                return
            }

            $scope.showConfirmCancelMessage = false

        }

        $scope.closeAllPanels = () => {
            $scope.showStyle = false
            $scope.showFont = false
        }

        $scope.cancelOverwrite = () => {

            if (isMobile && ($scope.showFont || $scope.showStyle)) {
                $scope.closeAllPanels()
                return
            }

            $scope.activate = false
            $scope.showConfirmOverwrite = false
        }

        $scope.createNewMessage = (activate, force) => {

            if (isMobile && ($scope.showFont || $scope.showStyle)) {
                $scope.closeAllPanels()
                return
            }

            if (!force && $scope.showConfirmOverwrite) {
                return
            }

            if (activate !== undefined) {
                $scope.activate = activate
            }

            if (!force && $scope.isOverwrite) {

                $scope.showConfirmOverwrite = true

            } else {

                $scope.working = true
                $scope.showConfirmOverwrite = false

                const multi = $scope.editController.toMulti()

                const success = function() {
                    gtag("event", "create_message", { action: "complete", device_id: $scope.messageBoard.device.id, slot: $scope.messageNumber, type: "TEXT" })
                    if ($scope.activate) gtag("event", "display_change", { action: "complete", device_id: $scope.messageBoard.device.id, slot_name: $scope.messageName })

                    $scope.working = false
                    userMessagingService.success("Message Creation Request Sent")
                }

                const failure = (error) => {
                    $scope.working = false
                    userMessagingService.error("Message Creation Failed: " + error)
                }

                const messageData = {
                    number:   $scope.messageNumber,
                    multi:    multi,
                    activate: $scope.activate
                }

                messagesService.createMessageV2($scope.messageBoard.id, messageData, success, failure)

                $uibModalInstance.close()

            }
        }

        const fontToolTips = {}

        $scope.getToolTipForFont = (font) => {

            const tipID = font.name + font.number

            if (fontToolTips[tipID]) {
                return fontToolTips[tipID]
            }

            fontToolTips[tipID] = $sce.trustAsHtml("<div><img src='' id='fontSample" + font.number + "' /></div>")

            $timeout(() => {

                angular.element(() => {

                    const fontSample = $scope.editController.interaction.getFontSample(font.number)

                    if (fontSample && fontSample.dataURL) {

                        const img = document.getElementById("fontSample" + font.number)

                        if (img) {
                            img.src = fontSample.dataURL
                            fontToolTips[tipID] = $sce.trustAsHtml("<div><img src='" + fontSample.dataURL + "' id='fontSample" + font.number + "' /></div>")
                        }
                    }
                })
            }, 1)

            return fontToolTips[tipID]

        }

        const onEditControllerUpdate = (data) => {

            $timeout(() => {
                $scope.canAddPage = data.page.canAddPage
                $scope.pages      = data.page.pages
                for (const page of $scope.pages) {
                    if (page.active) {
                        $scope.currentPageNumber = page.number
                        break
                    }
                }
            }, 1)

            $scope.fonts = data.fonts
            for (const font of data.fonts) {
                if (font.active) {
                    $scope.currentFont = font
                    break
                }
            }

            $scope.activeJustification.line = data.justification.line
            $scope.activeJustification.page = data.justification.page

            $scope.activeColor.foreground = data.color.foreground
            $scope.activeColor.background = data.color.background

            $scope.currentLineSpacing = data.spacing.line

        }

        $scope.$on('$destroy', () => {
            if ($scope.editController) {
                $scope.editController.dispose()
            }
        })

        angular.element(async () => {

            // Loading Edit Controller inside angular.element() to allow HTML to initialize first, GetEditController needs access to the DOM after HTML initialized

            let canvasWidth = 420
            const canvasContainerID = "messageContainer"

            if (isMobile) {

                $scope.showStyle = false

                if ($scope.messageBoard && $scope.messageBoard.hasOwnProperty("width_pixels") && $scope.messageBoard.hasOwnProperty("height_pixels")) {

                    const aspectRatio = $scope.messageBoard.width_pixels / $scope.messageBoard.height_pixels

                    let factor = 1

                    if (aspectRatio <= 1.67 && window.innerWidth <= 350) {

                        factor = 0.55

                        if (aspectRatio < 1.6) {

                            factor = 0.45

                        }

                    } else if (aspectRatio < 1.6) {

                        if (window.innerWidth <= 400) {

                            factor = 0.55

                            if (window.innerHeight >= 575) {
                                factor = 0.65
                            }

                        } else if (window.innerWidth <= 430) {

                            factor = 0.75

                        }
                    }

                    canvasWidth = Math.round(canvasWidth * factor)

                }
            }

            const loadingStart = Date.now()

            $scope.editController = await FMMessage.GetEditController($scope.messageBoard, canvasContainerID, canvasWidth, isMobile, onEditControllerUpdate)

            if ($scope.editController) {

                const canvasContainer = document.getElementById("messageContainer")

                if (canvasContainer) {
                    if (canvasContainer.children[0]) {
                        const height = window.getComputedStyle(canvasContainer.children[0]).getPropertyValue("height")
                        document.documentElement.style.setProperty("--message-window-height", height)
                    }
                }

                $timeout(() => {

                    onReady()

                }, Math.max(1, 650 - (Date.now() - loadingStart)))

            } else {

                onReady()

            }
        })
    }
})()
